import { ChainId } from '../../sdk/chainId'
import type { Currency } from '../../sdk/entities/currency'
import { getChain } from '../active'

import { buildNativeMap } from './buildNativeMap'

export const NATIVE: Partial<Record<ChainId, Currency>> = buildNativeMap()

export function getNativeCurrency(chainId: ChainId): Currency {
  const currency = NATIVE[chainId]
  if (!currency) {
    throw new Error(`[config/native] Cadena ${chainId} sin moneda nativa (configured o NATIVE no construido)`)
  }
  return currency
}

export function isNativeCurrency(currency: Currency, chainId: ChainId): boolean {
  const native = NATIVE[chainId]
  return native !== undefined && currency === native
}

export function getNativeCurrencySymbol(chainId: ChainId): string {
  return getChain(chainId).nativeCurrency.symbol
}

/** Id estable para rutas y URLs (`currencyId`). */
export function nativeCurrencyId(chainId: ChainId): string {
  return getNativeCurrencySymbol(chainId)
}

/** Comprueba si un id de URL/query coincide con la moneda nativa de la cadena. */
export function isNativeCurrencySymbol(symbol: string | undefined, chainId: ChainId): boolean {
  if (!symbol) return false
  const upper = symbol.toUpperCase()
  const native = getNativeCurrencySymbol(chainId).toUpperCase()
  return upper === native || upper === 'ETH'
}

/** Resuelve el `chainId` si la moneda es una instancia nativa registrada. */
export function getNativeChainIdForCurrency(currency: Currency): ChainId | undefined {
  for (const chainId of Object.keys(NATIVE).map((k) => Number(k) as ChainId)) {
    if (NATIVE[chainId] === currency) {
      return chainId
    }
  }
  return undefined
}
